import z from "zod";

import { validationOtpErrorMessages } from "../i18n/validation-error-codes.ts";

export const otpCodeSchema = z.string().min(1);

export const otpDigitsCodeSchema = z
  .string()
  .regex(/^\d{6}$/, validationOtpErrorMessages.invalidFormat.id);
